// Keep table -> server ID mapping stable while limiting concurrent writes.
// Wait for started requests even on failure, before the caller can retry.
export async function createImportedTables(tables, createTable) {
  const pending = tables.filter(table => Number(table.id) < 0);
  const idMap = {};
  let next = 0;
  let failure;
  const worker = async () => {
    while (!failure && next < pending.length) {
      const table = pending[next++];
      try {
        const created = await createTable({ ...table, id: undefined, frontend: false });
        const realId = Number(created?.id ?? created?.tableId);
        if (!Number.isFinite(realId) || realId <= 0) {
          throw new Error(`CREATED_TABLE_INVALID_ID:${table.id}`);
        }
        idMap[String(table.id)] = realId;
      } catch (error) { failure = error; }
    }
  };
  await Promise.all(Array.from({ length: Math.min(3, pending.length) }, worker));
  if (failure) throw failure;
  return idMap;
}
